import { type AnalyticsEvent } from '@autone/analytics';
import { type Metric } from '@autone/openapi-core';
import { type FC, type PropsWithChildren } from 'react';

import { ProductImage } from '../product-image/ProductImage';
import ProductColorMaterial from '../product-info/product-info-elements/ProductColorMaterial';
import { ProductId } from '../product-info/product-info-elements/ProductId';
import ProductPriceInfo from '../product-info/product-info-elements/ProductPriceInfo';
import { ProductTitle } from '../product-info/product-info-elements/ProductTitle';

type Props = PropsWithChildren<{
  imageUrl: string | null;
  styleDesc: string | null;
  materialDesc?: string | null;
  colorDesc?: string | null;
  productId: string;
  analyticsEvent?: AnalyticsEvent;
  price?: Metric;
  currency?: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}>;

export const ProductCell: FC<Props> = ({
  imageUrl,
  styleDesc,
  materialDesc,
  colorDesc,
  productId,
  analyticsEvent,
  children,
  price,
  currency,
  className,
  size,
}) => {
  return (
    <div className="flex flex-row items-center gap-4">
      <ProductImage
        imageUrl={imageUrl}
        allowZoom={true}
        className="object-contain"
        size={size}
      />
      <div className="flex flex-col gap-1">
        <ProductTitle title={styleDesc} className={className} />
        <ProductColorMaterial
          colorDesc={colorDesc}
          materialDesc={materialDesc}
          className={className}
        />
        <ProductId
          productId={productId}
          analyticsEvent={analyticsEvent}
          className={className}
        />
        {currency && (
          <ProductPriceInfo
            retailPrice={price?.rrp}
            wholesalePrice={price?.ws}
            currency={currency}
          />
        )}
      </div>
      {children}
    </div>
  );
};
